import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'
import {
    ContractCurrency,
} from 'app/enums/label.enums'
import {
    DTOCardFormField,
} from 'app/types/form.types'

export type ContractBasisInformationFields = Pick<
    ContractBasis, 'account' | 'customerQuotation' | 'currency'
> & {
    contractBasis: { id: number }
}

export default ({
    disabled,
    getAllowedValues,
    generateContractBasisLink,
}: {
    disabled: boolean,
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    generateContractBasisLink: (id: string | number) => string
}): DTOCardFormField<keyof ContractBasisInformationFields>[] => {
    return [{
        id: 'contractBasisSelectForm',
        title: 'Contract Basis Information',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'contractBasis',
                        componentName: 'ContractBasisSelector',
                        labelKey: 'LaneFeesView.cbNumber',
                        disabled,
                        required: true,
                        noneOption: false,
                        generateLink: generateContractBasisLink,
                    },
                    {
                        name: 'currency',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ContractCurrency),
                        labelKey: 'LaneOpsInformationDto.currency',
                        disabled: true,
                    },
                ],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'account',
                    componentName: 'AccountSelector',
                    labelKey: 'LaneGroup.pricingAccount',
                    disabled: true,
                }],
            },
            {
                id: 'column3',
                fields: [{
                    name: 'customerQuotation',
                    componentName: 'LocationObjectSelector',
                    disabled: true,
                    labelKey: 'ContractBasisCreateDto.customerQuotation',
                }],
            },
        ],
    }]
}
